import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

import React, { useContext, useEffect, useState } from 'react';

import { pageMapping } from './constants';

import axios from '../../../../common/AxiosConfig';

import { AppContext } from '../../../../../RoutesWithAuth';

import JsonViewer from '../../JsonViewer';


const useStyles = makeStyles(() => ({
    viewerWrapper: {
        height: '100%',
        padding: '16px',
    }
}));


const ViewJson = ({ tabInfo, setDisplayErrMsg, setLoading }) => {
    const context = useContext(AppContext);
    const authToken = context.authToken.get;
    const classes = useStyles();
    const [json, setJson] = useState();

    useEffect(() => {
        fetchData();

  // eslint-disable-next-line react-hooks/exhaustive-deps
},[tabInfo.tabtype]);

    const fetchData = () => {
        const pageLevelInfo = pageMapping[tabInfo.tabtype];
        let requestUrl = `${pageLevelInfo.urlPrefix || 'ticket'}/${tabInfo.dsarRequestId}/${pageLevelInfo.url}`;
        if (pageLevelInfo.app_id) {
            requestUrl = `${requestUrl}/?app_id=${pageLevelInfo.app_id}`;
        }
        if(pageLevelInfo.payload_type){
            let appender = '/?';
            if(requestUrl.indexOf('?') !== -1){
                appender = '&';
            }
            requestUrl = `${requestUrl}${appender}payload_type=${pageLevelInfo.payload_type}`;
        }
        setLoading(true)
        axios.get(requestUrl, {
            headers: {
                Authorization: authToken,
            },
        })
            .then((res) => {
                setLoading(false)
                let jsonData = res.data;
                if(pageLevelInfo["responseKeyMapper"]){
                    jsonData = res.data[pageLevelInfo["responseKeyMapper"]]
                }
                setJson(jsonData);
            })
            .catch((err) => {
                if (err?.response?.data?.message) {
                    setDisplayErrMsg(err.response.data.message)
                }
                setLoading(false);
                setJson("");
                console.log(err);
            });
    };

    const getFilename = () => {
        const dsarRequestId = tabInfo.dsarRequestId;
        return pageMapping[tabInfo.tabtype]?.downloadFileName?.(dsarRequestId) || `${dsarRequestId}.json`;
    };

    return (
        <Box className={classes.viewerWrapper}>
            {json ? (
                <JsonViewer 
                    data={json} 
                    filename={getFilename()}
                    containerStyle={{ maxHeight: 'calc(100vh - 300px)' }}
                />
            ) : (
                <Box p={2} textAlign="center" color="#94a3b8">
                    No data available
                </Box>
            )}
        </Box>
    )
}
export default React.memo(ViewJson);

